import { render, staticRenderFns } from "./DocumentPageNavigator.vue?vue&type=template&id=17c821c7&scoped=true&"
import script from "./DocumentPageNavigator.vue?vue&type=script&lang=ts&"
export * from "./DocumentPageNavigator.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentPageNavigator.vue?vue&type=style&index=0&id=17c821c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c821c7",
  null
  
)

export default component.exports